import { ReflectStorage } from '~helpers/ReflectStorage';
import { LocalStorageData, LocalStorageKeys } from '~types/LocalStorage';

export const LandingsStorage = (() => {
  const storage = new ReflectStorage();

  return {
    set<K extends keyof LocalStorageData = LocalStorageKeys>(
      key: K,
      value: LocalStorageData[K],
    ) {
      return storage.set(key, value);
    },
    get<K extends keyof LocalStorageData = LocalStorageKeys>(key: K) {
      return storage.get<LocalStorageData[K]>(key);
    },
    delete(key: keyof LocalStorageData) {
      return storage.remove(key);
    },
  };
})();
